@if(showSigningScreen){
<signing-screen [downloadId]="downloadId" (tokenError)="handleTokenError($event)"></signing-screen>
}
@else{
@if(showContent){
<section class="login">
    @if(emailStep === 'main'){
    @if(!domains && !tokens){
    <div class="login-container">
        <div class="login-card">
            @if(type === 'Sign'){
            <span class="material-symbols-outlined button-icon">signature</span>
            <h2>{{"Signing Service" | translate}}</h2>
            }
            @else {
            <mat-icon class="button-icon">people</mat-icon>
            <h2>{{"Share Service" | translate}}</h2>
            }
            @if(downloadId){
            <p class="subtitle">
                <b>{{ sharedBy }}</b> {{ "has shared document/s with you." | translate }}<br>
                @if(subject){
                <span class="summary">{{ subject }}</span><br>
                }
                {{ "Choose an option to authenticate your access." | translate }}
            </p>
            }
            @if(downloadId){
            <div class="login-buttons">
                <button class="btn plenion" (click)="showEmailInput()">
                    <span class="button-icon-bg">
                        <span class="icon">@</span>
                    </span>
                    <span class="button-text">{{ "Receive a code via email" | translate }}</span>
                </button>
                <button class="btn google" (click)="login('Google')">
                    <span class="button-icon-bg">
                        <svg xmlns="http://www.w3.org/2000/svg" width="22px" height="22px" viewBox="0 0 48 48">
                            <circle cx="24" cy="24" r="22" fill="#fff" />
                            <g>
                                <path fill="#EA4335"
                                    d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z" />
                                <path fill="#4285F4"
                                    d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z" />
                                <path fill="#FBBC05"
                                    d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z" />
                                <path fill="#34A853"
                                    d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z" />
                                <path fill="none" d="M0 0h48v48H0z"></path>
                            </g>
                        </svg>
                    </span>
                    <span class="button-text">{{ "Sign in with Google" | translate }}</span>
                </button>
                <button class="btn microsoft" (click)="login('Office')">
                    <span class="button-icon-bg">
                        <svg xmlns="http://www.w3.org/2000/svg" width="22px" height="22px" viewBox="0 0 21 21">
                            <circle cx="10.5" cy="10.5" r="10.5" fill="#fff" />
                            <rect x="3" y="3" width="7" height="7" fill="#f25022" />
                            <rect x="3" y="11" width="7" height="7" fill="#00a4ef" />
                            <rect x="11" y="3" width="7" height="7" fill="#7fba00" />
                            <rect x="11" y="11" width="7" height="7" fill="#ffb900" />
                        </svg>
                    </span>
                    <span class="button-text">{{ "Sign in with Microsoft" | translate }}</span>
                </button>
            </div>
            <div class="input-and-language">
                <div class="dropdown-language-container">
                    <div id="language-dropdown" [matMenuTriggerFor]="menuLanguage">
                        <span>{{ selected }}</span>
                        <mat-icon>keyboard_arrow_down</mat-icon>
                    </div>
                    <mat-menu #menuLanguage="matMenu">
                        <a (click)="onChangeLanguage('en')" value="EN" mat-menu-item>
                            <span>English</span>
                        </a>
                        <a (click)="onChangeLanguage('fr')" value="FR" mat-menu-item>
                            <span>Français</span>
                        </a>
                        <a (click)="onChangeLanguage('nl')" value="NL" mat-menu-item>
                            <span>Nederlands</span>
                        </a>
                    </mat-menu>
                </div>
            </div>
        }
        @else {
            <div style="text-align: center; margin-top: 20px;">
                <a href="https://www.plenion.be/" target="_blank" style="color: #0e2888; text-decoration: none;">
                    https://www.plenion.be/
                </a>
            </div>
        }
        </div>
    </div>
    }
    }
    @else if(emailStep === 'inputEmail'){
    <div class="login-container">
        <div class="login-card">
            <h2>{{"Select your email" | translate}}</h2>
            <mat-form-field appearance="fill" class="full-width">
                <mat-select [(value)]="selectedEmail" placeholder="Email">
                    @for (email of emailOptions; track email) {
                    <mat-option [value]="email">{{ email }}</mat-option>
                    } </mat-select>
            </mat-form-field>
            <button class="btn plenion" [disabled]="!selectedEmail" (click)="sendCode()">{{"Send Code" |
                translate}}</button>
        </div>
    </div>
    }
    @else if(emailStep === 'inputCode'){
    <div class="login-container">
        <div class="login-card">
            <h2>{{"Enter the Code" | translate}}</h2>
            <mat-form-field appearance="fill" class="full-width">
                <input matInput [formControl]="codeInput" type="text" placeholder="Code" />
            </mat-form-field>
            <button class="btn plenion" [disabled]="codeInput.invalid" (click)="verifyCode()">{{"Verify Code" |
                translate}}</button>
            <a class="resend-link" [class.disabled]="resendCooldown > 0" (click)="resendCode()">
                @if(resendCooldown > 0){
                {{"Resend code in" | translate}} {{resendCooldown}}s
                }
                @else {
                {{"Resend code" | translate}}
                }
            </a>
        </div>
    </div>
    }
</section>
}

}